import { useGetSegmentByKeyQuery } from '@api'
import { Button, Flexbox, Radio, Spacer, Text } from '@components/common'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FilterLoading from './FilterLoading'
import { AssetsTableFilterField } from './Filters.types'

interface Props {
  filter: AssetsTableFilterField
}

const SegmentsFilter = ({ filter }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchParamsObject = Object.fromEntries([...searchParams])

  const [segmentValue, setSegmentValue] = useState<string | undefined>(
    searchParams.get(filter.column) ?? undefined
  )

  const inputChangeTimeoutDuration: number = 400

  const {
    data: segments,
    isLoading: isLoadingSegments,
    isError: isErrorGettingSegments,
  } = useGetSegmentByKeyQuery({
    KY_NR: parseInt(filter.column.charAt(6)),
  })

  function onChange(e: any) {
    setSegmentValue(e.target.value)
    setTimeout(() => {
      if (e.target.value === '') {
        searchParams.delete(e.target.name)
        setSearchParams(searchParams)
      } else {
        setSearchParams({
          ...searchParamsObject,
          [e.target.name]: (e.target.value = typeof Number
            ? e.target.value.toString()
            : e.target.value),
          pageNumber: '1',
        })
      }
    }, inputChangeTimeoutDuration)
  }

  function clearSelection() {
    searchParams.delete(filter.column)
    setSearchParams(searchParams)
    setSegmentValue(undefined)
  }

  if (isErrorGettingSegments) {
    return <Text intent="danger">Error getting segments.</Text>
  }

  if (isLoadingSegments) {
    return <FilterLoading />
  }

  if (segments.length === 0) {
    return <Text>You haven't added any segments yet.</Text>
  }

  return (
    <div>
      <Spacer y="mini" />
      <Radio name={filter.column} onChange={onChange} select={segmentValue} legend="">
        {segments.map((segment, index: number) => (
          <Radio.Option
            value={segment.KY_VALUE}
            label={`${segment.KY_VALUE} (${segment.KY_DESC})`}
            autoFocus={index === 0}
            key={segment.KY_VALUE}
          />
        ))}
      </Radio>
      <Spacer y="mini" />
      <Flexbox justifyContent="flex-end">
        <Text small>
          <Button
            onClick={() => clearSelection()}
            appearance="text"
            disabled={segmentValue === '' || segmentValue === undefined}
          >
            Clear
          </Button>
        </Text>
      </Flexbox>
    </div>
  )
}
export default SegmentsFilter
